<app-nav-steps *ngIf="!isDetailsView"></app-nav-steps>
<div class="personal-data-container component-container">
  <div *ngIf="!isDetailsView" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div *ngIf="currentInstallationFlow === installationFlowType.NewInstallation" class="page-heading text-center text-uppercase">
      {{ 'personal-data.heading' | translate }}
    </div>
    <div *ngIf="currentInstallationFlow === installationFlowType.UpdateInstallation" class="page-heading text-center text-uppercase">
      {{ 'personal-data.update-installation.heading' | translate }}
    </div>
    <div *ngIf="showTechnicianDataTitle" class="page-heading text-center text-uppercase">
      {{ 'installation-data.' + getFlowTitle() | translate }}
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'personal-data.title' | translate }}
      <span *ngIf="currentInstallationFlow === installationFlowType.MainsConnection">
        - {{ 'lookup.' + buildingTypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
      <span
        *ngIf="
          currentInstallationFlow === installationFlowType.ChangeHouseConnection ||
          currentInstallationFlow === installationFlowType.ConversionToGas
        ">
        - {{ 'lookup.' + changeSubtypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
      <span *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem">
        - {{ 'lookup.' + feedInTypeKey + '.options.' + feedInInstallationType + '.name' | translate }}
      </span>
    </div>
  </div>

  <app-connection-address *ngIf="connectionData" [connectionData]="connectionData" [isReadOnly]="isReadOnly"></app-connection-address>
  <app-location-fields
    [areaLocations]="areaLocations"
    [isDisabled]="isReadOnly"
    [isDetailsView]="isReadOnly"
    (onRemoveAreaLocation)="removeAreaLocation($event)"></app-location-fields>

  <app-subscriber
    *ngIf="subscriberData"
    [connectionData]="connectionData"
    [isReadOnly]="isReadOnly"
    [subscriberData]="subscriberData"
    [documents]="documents"></app-subscriber>
  <app-technician-info *ngIf="isReadOnly || isDetailsView" [isReadOnly]="true" [technicianData]="technicianData"></app-technician-info>

  <app-invoice-address *ngIf="showInvoiceAddress" [isReadOnly]="isReadOnly" [invoiceAddress]="invoiceAddress"></app-invoice-address>

  <app-responsible-installer
    *ngIf="showInstallerComponent"
    [installerData]="installerData"
    [isReadOnly]="isReadOnly"></app-responsible-installer>
  <app-installer-company
    *ngIf="showInstallerCompanyComponent"
    [isReadOnly]="isReadOnly"
    [systemCompanyInstallerData]="installerCompanyData"></app-installer-company>

  <div *ngIf="!isReadOnly && !isDetailsView" class="ui-g-12 submit-button-section text-center">
    <button
      (click)="saveFormData()"
      [disabled]="disableFormButtons || isLoading"
      class="submit-button"
      label="{{ 'basic-profile.jurisdiction.proceed' | translate | uppercase }}"
      pButton></button>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
